import { render, staticRenderFns } from "./ServingsCounter.vue?vue&type=template&id=15dc7c30"
import script from "./ServingsCounter.vue?vue&type=script&lang=js"
export * from "./ServingsCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports